<template>
  <div class="rightModal">
    <b-form-group
      :label="$t('servers.operatingSystem')"
      :state="validateState('os')"
    >
      <multiselect
        v-model="form.os"
        :options="osList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('servers.operatingSystem')"
        :show-no-results="false"
      />
    </b-form-group>

    <InfoBox v-if="infoMessage != ''">
      <div v-html="infoMessage"></div>
    </InfoBox>

    <Input
      label="servers.distribution"
      placeholder="servers.enterDistribution"
      id="distro"
      v-model="form.distro"
      :state="validateState('distro')"
    />

    <Input
      label="servers.distributionVersion"
      placeholder="servers.enterDistributionVersion"
      id="version"
      v-model="form.version"
      :state="validateState('version')"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ConvertToTemplate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    vmData: Array | Object,
  },
  data() {
    return {
      form: {
        os: '',
        distro: '',
        version: '',
      },
      osList: [
        { id: 'Linux', name: 'Linux' },
        { id: 'Microsoft Windows', name: 'Microsoft Windows' },
      ],
      infoMessage: '',
    }
  },
  validations: {
    form: {
      os: {
        required,
      },
      distro: {
        required,
      },
      version: {
        required,
      },
    },
  },
  created() {
    this.controlIsFarm()
  },
  methods: {
    controlIsFarm() {
      let isFarm = !(
        this.vmData.datacenterNode &&
        this.vmData.datacenterNode.data &&
        this.vmData.datacenterNode.data.pricing_model == 'resource'
      )

      if (isFarm) {
        let dcName =
          this.vmData.datacenterNode && this.vmData.datacenterNode.data
            ? this.vmData.datacenterNode.data.name
            : ''

        this.infoMessage = this.$t(
          'forms.vm.convertToTemplateInfoFarm'
        ).replace('{0}', dcName)
      } else {
        this.infoMessage = this.$t('forms.vm.convertToTemplateInfo')
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        is_public: 0,
        os: this.form.os.id,
        distro: this.form.distro,
        version: this.form.version,
      }
      ApiService.put(
        `iaas/virtual-machines/templates/${this.vmData.id}`,
        params
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
